import React from "react";

const OtherTask = ({ label }) => {
  return (
    <div className="w-40 h-5 bg-blue-200 rounded-2xl flex items-center px-2">
      <span className="text-slate-700 text-[10px] font-medium truncate">{label}</span>
    </div>
  );
};

export default OtherTask;
